import { render, staticRenderFns } from "./superAdminView.vue?vue&type=template&id=0f7b4b0c&"
import script from "./superAdminView.vue?vue&type=script&lang=js&"
export * from "./superAdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports